const key = { enter: 13, space: 32 };

class DigitalPayToggleButtonController {
    onKeyDown($event) {
        if ($event.keyCode === key.enter || $event.keyCode === key.space) {
            this.onClick();
        }
    }
}

const digitalPayToggleButtonComponentDefinition = {
    controller: DigitalPayToggleButtonController,
    template: require('./digital-pay-toggle-button.component.html').trim(),
    bindings: {
        icon: '@',
        iconClass: '@', // Class to apply for the icon (to resize if needed)
        instrumentName: '@',
        subText: '@?', // Replaces instrument name, but is styled to fit more text
        amount: '<?',
        linkText: '@?',
        isIconSvg: '<?',
        isSelectButton: '<', // If false, this is a toggleable button
        isSelected: '<?',
        isDisabled: '<?',
        isToggled: '<?',
        isLoading: '<?',
        isErrored: '<?',
        isNotBottom: '<?', // Not the bottom element (affects rounded corners)
        onClick: '&',
        shouldShowPayingAmount: '<',
    },
};

module.exports = {
    DigitalPayToggleButtonController,
    digitalPayToggleButtonComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/wallet/common/digital-pay-toggle-button.component.js